/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Fragment } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import PaginatedTable from '../../../components/PaginatedTable';
import { useCompanionEmailsQuery } from '../../../generated/graphql';
import EmailListItem from '../../emails/components/EmailListItem';
import { ContentCard, ContentCardHeader } from '../../../components/ContentCard';
import { Elevation } from '@blueprintjs/core';
import PaginationBar from '../../../components/PaginationBar';
import { dummyEmails } from '../../emails/dummy';

const CompanionEmails = () => {
  const [emailPage, setEmailPage] = useState(1);
  const { companionId } = useParams();
  const { data, loading, error } = useCompanionEmailsQuery({
    fetchPolicy: 'network-only',
    variables: {
      id: companionId || '',
      page: emailPage,
    },
  });

  const { data: emails, paginatorInfo } = data?.companion?.emails || {};
  const { currentPage, lastPage, hasMorePages } = paginatorInfo || {};

  return (
    <ContentCard elevation={Elevation.TWO} css={styles.spacedCard}>
      <ContentCardHeader
        leftElement={
          <Fragment>
            <span css={styles.heading}>Emails</span>
          </Fragment>
        }
      />
      <PaginatedTable
        columns={['Status', 'Betreff', 'Datum / Uhrzeit']}
        interactive
        loading={loading}
        hasError={!!error}
        empty={!emails?.length}
      >
        {(loading ? dummyEmails : emails || []).map((email) => (
          <EmailListItem key={email.id} item={email} skeleton={loading} />
        ))}
      </PaginatedTable>
      <PaginationBar
        loading={loading}
        empty={!emails?.length}
        currentPage={currentPage}
        lastPage={lastPage}
        hasMorePages={hasMorePages}
        onPrev={() => setEmailPage(currentPage && currentPage > 0 ? currentPage - 1 : 1)}
        onNext={() => setEmailPage(currentPage ? currentPage + 1 : 1)}
      />
    </ContentCard>
  );
};

export default CompanionEmails;

const styles = {
  heading: css`
    font-size: 16px;
  `,
  spacedCard: css`
    margin-bottom: 20px;
  `,
};
